import React from 'react';
import './Footer.css'

const Footer = () => {
  return (
    <footer className="appFooter no-print">
      <span>© {new Date().getFullYear()} Facturator</span>
    </footer>
  );
}

export default Footer;
